export class PHPLanguage
{
  public static readonly token ="php";

  public static readonly keywords:string[] = 
  [
    "$this", "static", "new",
    "string", "int", "array"
  ]
  
  public static readonly keywords2:string[] = 
  [
    "function"
  ]
  
}